import { render, staticRenderFns } from "./AgreedItem.vue?vue&type=template&id=33bb4475&scoped=true&"
import script from "./AgreedItem.vue?vue&type=script&lang=js&"
export * from "./AgreedItem.vue?vue&type=script&lang=js&"
import style0 from "./AgreedItem.vue?vue&type=style&index=0&id=33bb4475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb4475",
  null
  
)

export default component.exports